import { LTLState } from "@taskpane/hooks/useLTLReducer";
import { lookupStateFromZip } from "@taskpane/utils/formUtils";

export function routeShipmentDetailInput(
  name: string,
  resolved: string,
  onFieldChange: (field: keyof LTLState["form"], value: string) => void
): void {
  if (name === "originZip") {
    const st = lookupStateFromZip(resolved);

    onFieldChange("originZip", resolved);
    if (st) {
      onFieldChange("originState", st);
    }
    return;
  }
  if (name === "destinationZip") {
    const st = lookupStateFromZip(resolved);

    onFieldChange("destinationZip", resolved);
    if (st) {
      onFieldChange("destinationState", st);
    }
    return;
  }
  onFieldChange(name as keyof LTLState["form"], resolved);
}
